import React, { useEffect, useState } from 'react'
import '../../assets/css/dairiten.css'
import ButtonImage from '../../assets/images/btn_form.gif'
import { CDP_API_URL, CDP_PUBLIC_URL } from '../../utils/Constants'
import { errorMessages } from '../form/FormValidationRules'
import { address, areaText, birthday, kanjiName, kannaName, lifeInsurance, main, metlife, names, phoneNo, subHead1, subHead2, subHeadTop } from '../../utils/DairitenText'
import InputScreenErrorMessage from '../InputScreenErrorMessage'
import { useLocation, useNavigate } from 'react-router-dom'
import { headers } from '../../api/CDPAPI'
import axios from 'axios'
const DairitenFormPage = () => {
    document.title = 'お問い合わせ／エントリー｜メットライフ生命'
    const navigate = useNavigate()
    const location = useLocation()
    const dataFromConfirmPage = location.state
    const [data, setData] = useState({})
    const [companyname, setCompanyName] = useState('')
    const [name, setName] = useState('')
    const [nameKanna, setNameKanna] = useState('')
    const [year, setYear] = useState('')
    const [month, setMonth] = useState('')
    const [day, setDay] = useState('')
    const [typeOfCalender, setTypeOfCalender] = useState('西暦')
    const [otherValue, setOtherValue] = useState('')
    const [tel1, setTel1] = useState('')
    const [tel2, setTel2] = useState('')
    const [typeOfPref, setTypeOfPref] = useState('都道府県')
    const [ward, setWard] = useState('')
    const [town, setTown] = useState('')
    const [apartment, setApartment] = useState('')
    const [phoneNumber, setPhoneNumber] = useState('')
    const [email, setEmail] = useState('')
    const [textArea, setTextArea] = useState('')
    const [mainIndustry, setMainIndustry] = useState([])
    const [lifeInsurances, setLifeInsurances] = useState('')
    const [metlifeInsurances, setMetlifeInsurances] = useState('')
    const [inputDisable, setInputDisable] = useState(false)
    const [error, setError] = useState({})
    const OnChangeCompanyName = (e) => {
        setCompanyName(e.target.value)
    }
    const OnChangeName = (e) => {
        setName(halfWidthSpace(e.target.value))
    }
    const OnChangeNameKanna = (e) => {
        setNameKanna(halfWidthSpace(e.target.value))
    }
    const OnChangeYear = (e) => {
        setYear(e.target.value)
    }
    const OnChangeMonth = (e) => {
        setMonth(e.target.value)
    }
    const OnChangeDay = (e) => {
        setDay(e.target.value)
    }
    /* const OnChangeType = (e) => {
        setTypeOfCalender(e.target.value)
    } */
    const OnChangeTel1 = (e) => {
        setTel1(e.target.value)
    }
    const OnChangeTel2 = (e) => {
        setTel2(e.target.value)
    }
    const OnChangePref = (e) => {
        setTypeOfPref(e.target.value)
    }
    const OnChangeWard = (e) => {
        setWard(halfWidthSpace(e.target.value))
    }
    const OnChangeTown = (e) => {
        setTown(halfWidthSpace(e.target.value))
    }
    const OnChangeApartment = (e) => {
        setApartment(halfWidthSpace(e.target.value))
    }
    const OnChangePhoneNumber = (e) => {
        setPhoneNumber(e.target.value)
    }
    const OnChangeEmail = (e) => {
        setEmail(e.target.value)
    }
    const OnChangeLifeInsurances = (e) => {
        setLifeInsurances(e.target.value)
    }
    const OnChangeMetlifeInsurances = (e) => {
        setMetlifeInsurances(e.target.value)
    }
    const OnChangeTextArea = (e) => {
        setTextArea(e.target.value)
    }
    const halfWidthSpace = (value) => {
        return value.replace(' ', '　')
    }
    const handleChangeData = (event) => {
        if (event.target.type === 'checkbox') {
            if (event.target.checked) {
                setData({ ...data, [event.target.id]: event.target.value })
            } else {
                const { [event.target.id]: removedProp, ...newValues } = data
                setData(newValues)
            }
        } else if (event.target.type !== 'checkbox') {
            setData({ ...data, [event.target.name]: event.target.value })
        }
        setError((prevErrors) => ({
            ...prevErrors,
            [name]: ''
        }))
    }
    const onChangeMainIndustry = (e) => {
        if (e.target.checked && e.target.value !== '') {
            setMainIndustry([...mainIndustry, e.target.value])
        } else {
            setMainIndustry(mainIndustry.filter(val => val !== e.target.value))
        }
    }
    const onChangeOtherValue = (e) => {
        setInputDisable(e.target.checked)
    }
    const onChangeOtherInput = (e) => {
        setOtherValue('その他：' + e.target.value)
    }
    const OnClickAutoZipCodeButton = async () => {
        const data = {
            contactZipcode1: tel1,
            contactZipcode2: tel2
        }
        await axios.post(`${CDP_API_URL}/getAddress-from-zipcode`, {
            ...data
        }, { headers: headers })
            .then(response => {
                response.data &&
                setTypeOfPref(response.data.prefecture)
                setWard(response.data.city.replace(' ', ''))
                setTown(response.data.town.replace(' ', ''))
            })
            .catch(error => {
                console.error(error)
                alert('検索が失敗しました。')
            })
    }
    const submitButtonClick = () => {
        // const InputData = {
        //     agencyName: companyname,
        //     kanjiName: name,
        //     kanaName: nameKanna,
        //     calendarType: typeOfCalender,
        //     birthYear: year,
        //     birthMonth: month,
        //     birthDate: day,
        //     occupation: mainIndustry,
        //     zipCode1: tel1,
        //     zipCode2: tel2,
        //     pref: typeOfPref,
        //     address1: ward,
        //     address2: town,
        //     address3: apartment,
        //     telephone: phoneNumber,
        //     email: email,
        //     experienceOfSellingInsurance: lifeInsurances,
        //     registrationHistory: metlifeInsurances,
        //     remarks: textArea
        // }
        fetchDairitenData()
    }
    // ----Api Integration for Validation ------ //
    const fetchDairitenData = async () => {
        const data = {
            agencyName: companyname,
            kanjiName: name,
            kanaName: nameKanna,
            calendarType: typeOfCalender,
            birthYear: year,
            birthMonth: month,
            birthDate: day,
            occupation: otherValue !== '' ? [...mainIndustry, otherValue] : mainIndustry,
            zipCode1: tel1,
            zipCode2: tel2,
            pref: typeOfPref,
            address1: ward,
            address2: town,
            address3: apartment,
            telephone: phoneNumber,
            email: email,
            experienceOfSellingInsurance: lifeInsurances,
            registrationHistory: metlifeInsurances,
            remarks: textArea
        }
        try {
            const response = await fetch(`${CDP_API_URL}/dairiten-validate-names`, {
                method: 'POST',
                headers: headers,
                body: JSON.stringify(data)
            })
            const data1 = await response.json()
            const newError = {}
            data1.systemMessages.forEach(item => {
                if (item.messageCode === 'datavalidated') {
                    const InputData = {
                        agencyName: companyname,
                        kanjiName: name,
                        kanaName: nameKanna,
                        calendarType: typeOfCalender,
                        birthYear: year,
                        birthMonth: month,
                        birthDate: day,
                        occupation: otherValue !== '' ? [...mainIndustry, otherValue] : mainIndustry,
                        zipCode1: tel1,
                        zipCode2: tel2,
                        pref: typeOfPref,
                        address1: ward,
                        address2: town,
                        address3: apartment,
                        telephone: phoneNumber,
                        email: email,
                        experienceOfSellingInsurance: lifeInsurances,
                        registrationHistory: metlifeInsurances,
                        remarks: textArea
                    }
                    navigate(`${CDP_PUBLIC_URL}/agency/confirm`, { state: InputData })
                } else if (item.messageCode === 'SVC_10_500_9') {
                    newError.charLimitName = errorMessages.charLimit30
                } else if (item.messageCode === 'SVC_10_400_21') {
                    newError.blankKanji = errorMessages.ifEmpty
                } else if (item.messageCode === 'SVC_10_400_36') {
                    newError.charLimitKanji = errorMessages.charLimit30
                } else if (item.messageCode === 'SVC_10_400_22') {
                    newError.charNotValidKanji = errorMessages.invalidInput
                } else if (item.messageCode === 'SVC_10_400_25') {
                    newError.blankKana = errorMessages.ifEmpty
                } else if (item.messageCode === 'SVC_10_400_38') {
                    newError.charLimitKana = errorMessages.charLimit30
                } else if (item.messageCode === 'SVC_10_400_26') {
                    newError.charNotValidKana = errorMessages.invalidKana
                } else if (item.messageCode === 'SVC_10_400_29') {
                    newError.blankZip = errorMessages.ifEmpty
                } else if (item.messageCode === 'SVC_10_400_30_1') {
                    newError.charLimitZip1 = errorMessages.charLimit3
                } else if (item.messageCode === 'SVC_10_400_30_2') {
                    newError.charLimitZip2 = errorMessages.charLimit4
                } else if (item.messageCode === 'SVC_10_400_31') {
                    newError.charNotValidZip = errorMessages.invalidInput
                } else if (item.messageCode === 'SVC_10_500_12') {
                    newError.charNotValidOther = errorMessages.invalidInput
                } else if (item.messageCode === 'SVC_10_500_10') {
                    newError.charLimitOther = errorMessages.charLimit15
                } else if (item.messageCode === 'SVC_10_500_4') {
                    newError.blankAddress = errorMessages.ifEmpty
                } else if (item.messageCode === 'SVC_10_500_5') {
                    newError.charLimitAddress = errorMessages.charLimit30
                } else if (item.messageCode === 'SVC_10_500_6') {
                    newError.charNotValidAddress = errorMessages.invalidInput
                } else if (item.messageCode === 'SVC_10_400_32') {
                    newError.blankPhone = errorMessages.ifEmpty
                } else if (item.messageCode === 'SVC_10_400_37') {
                    newError.charLimitPhone = errorMessages.charLimit15
                } else if (item.messageCode === 'SVC_10_400_33') {
                    newError.charNotValidPhone = errorMessages.invalidInput
                } else if (item.messageCode === 'SVC_10_400_34') {
                    newError.blankEmail = errorMessages.ifEmpty
                } else if (item.messageCode === 'SVC_10_400_35') {
                    newError.isNotEmail = errorMessages.invalidInput
                } else if (item.messageCode === 'SVC_10_400_95') {
                    newError.charLimitEmail = errorMessages.charLimit30
                } else if (item.messageCode === 'SVC_10_500_1') {
                    newError.blankExperience = errorMessages.ifEmpty
                } else if (item.messageCode === 'SVC_10_500_7') {
                    newError.blankRegistration = errorMessages.ifEmpty
                } else if (item.messageCode === 'SVC_10_500_2') {
                    newError.charLimitRemarks = errorMessages.charLimit500
                } else if (item.messageCode === 'SVC_10_400_18') {
                    newError.invalidYear = errorMessages.invalidInput
                } else if (item.messageCode === 'SVC_10_500_10') {
                    newError.charLimitOther = errorMessages.charLimit15
                }
            })
            setError(newError)
        } catch (error) {
            alert('送信エラーが発生しました')
        }
    }
    useEffect(() => {
        if (dataFromConfirmPage) {
            setCompanyName(dataFromConfirmPage.agencyName)
            setName(dataFromConfirmPage.kanjiName)
            setNameKanna(dataFromConfirmPage.kanaName)
            setYear(dataFromConfirmPage.birthYear)
            setMonth(dataFromConfirmPage.birthMonth)
            setDay(dataFromConfirmPage.birthDate)
            setTypeOfCalender(dataFromConfirmPage.calendarType)
            setTel1(dataFromConfirmPage.zipCode1)
            setTel2(dataFromConfirmPage.zipCode2)
            setTypeOfPref(dataFromConfirmPage.pref)
            setWard(dataFromConfirmPage.address1)
            setTown(dataFromConfirmPage.address2)
            setApartment(dataFromConfirmPage.address3)
            setPhoneNumber(dataFromConfirmPage.telephone)
            setEmail(dataFromConfirmPage.email)
            setTextArea(dataFromConfirmPage.remarks)
            // setMainIndustry(dataFromConfirmPage.occupation)
            // setLifeInsurances(dataFromConfirmPage.experienceOfSellingInsurance)
            // setMetlifeInsurances(dataFromConfirmPage.registrationHistory)
            window.history.replaceState({}, dataFromConfirmPage)
        }
    }, [])
    return (
        <div className="dairiten-input-section-inputdetails row">
            <div className="col-lg-3 col-md-12">
                <div id="subFrame">
                    <div className="subLinkWrap" id="inLine">
                        <h2 className="subHeading01" id="h22"><a href="http://www.metlife.co.jp/agency/">{subHeadTop}</a></h2>
                        <ul className="subLinkList01">
                            <li><a href="http://www.metlife.co.jp/agency/merit/" id="a1">{subHead1}</a></li>
                            <li><a href="http://www.metlife.co.jp/agency/support/" id="a1">{subHead2}</a></li>
                        </ul>
                    </div>
                </div>
            </div>
            <div className="col-sm-12 col-md-12 col-lg-9">
            <div id="headerFrame12">
            </div>
            <div className="">
                <h1 id="h1">お問い合わせ／エントリー<br></br><p id="p1">※代理店登録にあたっては業界経験など当社条件等満たしていただく必要があります。</p></h1>
                <h2 id="h2">エントリーフォーム</h2>
                <p>必要事項を入力の上、「送信」ボタンを押してください。</p>
                <div className="card-container-inputdetails">
                    <div className="row">
                        <span id="span1">基本情報</span>
                        <div className="col-lg-3 col-md-3 col-sm-12 col-12 titleDiv">
                            <label htmlFor="inputtext" className="col-form-label l1">{names}</label>
                        </div>
                        <div className="col-lg-9 col-md-9 col-sm-12 col-12 contentDiv">
                                <input type="text" id="text12" onChange={OnChangeCompanyName} value={companyname} />
                                <div className="errDisplayArea">
                                    <InputScreenErrorMessage errorMessage={error.charLimitName}></InputScreenErrorMessage>
                                </div>
                        </div>
                        <div className="col-lg-3 col-md-3 col-sm-12 col-12 titleDiv">
                            <label htmlFor="inputtext" className="col-form-label l1">{kanjiName}<em className="star">※必須</em></label>
                        </div>
                        <div className="col-lg-9 col-md-9 col-sm-12 col-12 contentDiv">
                                <span className="note">（全角でご入力ください　例：保険　太郎）</span><br></br>
                                <input type="text" onChange={OnChangeName} value={name} />
                                <div className="errDisplayArea">
                                    <InputScreenErrorMessage errorMessage={error.blankKanji}></InputScreenErrorMessage>
                                    <InputScreenErrorMessage errorMessage={error.charLimitKanji}></InputScreenErrorMessage>
                                    <InputScreenErrorMessage errorMessage={error.charNotValidKanji}></InputScreenErrorMessage>
                                </div>
                        </div>
                        <div className="col-lg-3 col-md-3 col-sm-12 col-12 titleDiv">
                            <label htmlFor="inputtext" className="col-form-label l1">{kannaName}<em className="star">※必須</em></label>
                        </div>
                        <div className="col-lg-9 col-md-9 col-sm-12 col-12 contentDiv">
                                <span className="note">（全角でご入力ください　例：ホケン　タロウ）</span><br></br>
                                <input type="text" onChange={OnChangeNameKanna} value={nameKanna} />
                                <div className="errDisplayArea">
                                    <InputScreenErrorMessage errorMessage={error.blankKana}></InputScreenErrorMessage>
                                    <InputScreenErrorMessage errorMessage={error.charLimitKana}></InputScreenErrorMessage>
                                    <InputScreenErrorMessage errorMessage={error.charNotValidKana}></InputScreenErrorMessage>
                                </div>
                        </div>
                        <div className="col-lg-3 col-md-3 col-sm-12 col-12 titleDiv">
                            <label htmlFor="inputtext" className="col-form-label l1">{birthday}<em className="star">※必須</em></label>
                        </div>
                        <div className="col-lg-9 col-md-9 col-sm-12 col-12 contentDiv">
                                <input type="text" id="birth_era" value={typeOfCalender} disabled />
                                <input type="text" id="birth_era" maxLength={4} onChange={OnChangeYear} value={year} /><span id="birth_era">年</span>
                                <select name="birth_month" id="birth_month" onChange={OnChangeMonth} value={month}>
                                    <option value="">&nbsp;</option>
                                    {Array.from({ length: 12 }, (_, index) => index + 1).map((item) => (
                                      <option key={item} value={item}>{item}</option>
                                    ))}
                                </select><span id="birth_month">月</span>
                                <select name="birth_day" id="birth_day" onChange={OnChangeDay} value={day}>
                                    <option value="">&nbsp;</option>
                                    {Array.from({ length: 31 }, (_, index) => index + 1).map((item) => (
                                      <option key={item} value={item}>{item}</option>
                                    ))}
                                </select><span>日</span>
                                <div className="errDisplayArea">
                                    <InputScreenErrorMessage errorMessage={error.invalidYear}></InputScreenErrorMessage>
                                </div>
                        </div>
                        <div className="col-lg-3 col-md-3 col-sm-12 col-12 titleDiv">
                            <label htmlFor="inputtext" className="col-form-label l1">{main}<em className="star">※必須</em></label>
                        </div>
                        <div className="col-lg-9 col-md-9 col-sm-12 col-12 contentDiv">
                            <div className="row" value={mainIndustry} onClick={handleChangeData} onChange={(e) => onChangeMainIndustry(e)}>
                                {/* <tbody>
                                            <tr value={mainIndustry} onClick={handleChangeData} onChange={(e) => onChangeMainIndustry(e)}>
                                                <td><input type="checkbox" name='mainIndustry' value='生命保険販売、'></input>生命保険販売、</td>
                                                <td><input type="checkbox" name='mainIndustry' value='損害保険販売、'></input>損害保険販売、</td>
                                                <td><input type="checkbox" name='mainIndustry' value='損害保険販売、'></input>税理士・公認会計士、</td></tr>
                                                <tr value={mainIndustry} onClick={handleChangeData} onChange={(e) => onChangeMainIndustry(e)}>
                                                <td><input type="checkbox" name='mainIndustry' value='損害保険販売、'></input>IFA</td>
                                                <td><input type="checkbox" name='mainIndustry' value='その他'></input>その他</td><input type="text" name='mainIndustry' value=''></input>
                                            </tr>
                                        </tbody> */}
                                <div className='checkboxWrap col-lg-6 col-md-6 col-sm-12 col-12'><input type="checkbox" value="生命保険販売" />
                                    &nbsp;&nbsp;生命保険販売</div>
                                <div className='checkboxWrap col-lg-6 col-md-6 col-sm-12 col-12'><input type="checkbox" value="損害保険販売" />
                                    &nbsp;&nbsp;損害保険販売</div>
                                <div className='checkboxWrap col-lg-6 col-md-6 col-sm-12 col-12'><input type="checkbox" value="税理士・公認会計士" />
                                    &nbsp;&nbsp;税理士・公認会計士</div>
                                <div className='checkboxWrap col-lg-6 col-md-6 col-sm-12 col-12'><input type="checkbox" value="IFA" />
                                    &nbsp;&nbsp;IFA</div>
                                <div className='checkboxWrap col-12'><input type="checkbox" value={otherValue} checked={inputDisable} onChange={(e) => onChangeOtherValue(e)} />
                                    &nbsp;&nbsp;その他&nbsp;
                                <input type="text" id="line" disabled={!inputDisable} onChange={(e) => onChangeOtherInput(e)} /></div>
                            </div>
                            <div className="errDisplayArea">
                                <InputScreenErrorMessage errorMessage={error.charLimitOther}></InputScreenErrorMessage>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="">
                <div className="card-container-inputdetails">
                    <div className="row">
                        <span id="span1">ご住所・お電話番号</span>
                        <div className="col-lg-3 col-md-3 col-sm-12 col-12 titleDiv">
                            <label htmlFor="inputtext" className="col-form-label l1">{address}<em className="star">※必須</em></label>
                        </div>
                        <div className="col-lg-9 col-md-9 col-sm-12 col-12 contentDiv">
                            <span className="note">（半角数字でご入力ください。例：123-4567）</span><br></br>
                            <span htmlFor="inputtext"><label>〒</label></span><input type="text" id='text1' maxLength={3} onChange={OnChangeTel1} value={tel1} /><span>-</span>
                            <input type="text" id='text1' maxLength={4} onChange={OnChangeTel2} value={tel2} />
                            <button type="button" id='button' onClick={OnClickAutoZipCodeButton}>検索</button><br></br>
                            <div className="errDisplayArea">
                                <InputScreenErrorMessage errorMessage={error.blankZip}></InputScreenErrorMessage>
                                <InputScreenErrorMessage errorMessage={error.charLimitZip1}></InputScreenErrorMessage>
                                <InputScreenErrorMessage errorMessage={error.charLimitZip2}></InputScreenErrorMessage>
                                <InputScreenErrorMessage errorMessage={error.charNotValidZip}></InputScreenErrorMessage>
                            </div>
                            <select className="132_DATA" id="pref" onChange={OnChangePref} value={typeOfPref} style={{ height: '25px', marginBottom: '15px' }}>
                                <option value="">都道府県</option>
                                <optgroup label="北海道・東北">
                                    <option value="北海道">北海道</option>
                                    <option value="青森県">青森県</option>
                                    <option value="岩手県">岩手県</option>
                                    <option value="秋田県">秋田県</option>
                                    <option value="宮城県">宮城県</option>
                                    <option value="山形県">山形県</option>
                                    <option value="福島県">福島県</option>
                                </optgroup>
                                <optgroup label="関東">
                                    <option value="東京都">東京都</option>
                                    <option value="神奈川県">神奈川県</option>
                                    <option value="埼玉県">埼玉県</option>
                                    <option value="千葉県">千葉県</option>
                                    <option value="茨城県">茨城県</option>
                                    <option value="栃木県">栃木県</option>
                                    <option value="群馬県">群馬県</option>
                                </optgroup>
                                <optgroup label="甲信越・北陸">
                                    <option value="新潟県">新潟県</option>
                                    <option value="富山県">富山県</option>
                                    <option value="石川県">石川県</option>
                                    <option value="福井県">福井県</option>
                                    <option value="山梨県">山梨県</option>
                                    <option value="長野県">長野県</option>
                                </optgroup>
                                <optgroup label="東海">
                                    <option value="岐阜県">岐阜県</option>
                                    <option value="静岡県">静岡県</option>
                                    <option value="愛知県">愛知県</option>
                                    <option value="三重県">三重県</option>
                                </optgroup>
                                <optgroup label="近畿">
                                    <option value="滋賀県">滋賀県</option>
                                    <option value="京都府">京都府</option>
                                    <option value="大阪府">大阪府</option>
                                    <option value="兵庫県">兵庫県</option>
                                    <option value="奈良県">奈良県</option>
                                    <option value="和歌山県">和歌山県</option>
                                </optgroup>
                                <optgroup label="中国">
                                    <option value="鳥取県">鳥取県</option>
                                    <option value="島根県">島根県</option>
                                    <option value="岡山県">岡山県</option>
                                    <option value="広島県">広島県</option>
                                    <option value="山口県">山口県</option>
                                </optgroup>
                                <optgroup label="四国">
                                    <option value="徳島県">徳島県</option>
                                    <option value="香川県">香川県</option>
                                    <option value="愛媛県">愛媛県</option>
                                    <option value="高知県">高知県</option>
                                </optgroup>
                                <optgroup label="九州・沖縄">
                                    <option value="福岡県">福岡県</option>
                                    <option value="佐賀県">佐賀県</option>
                                    <option value="長崎県">長崎県</option>
                                    <option value="熊本県">熊本県</option>
                                    <option value="大分県">大分県</option>
                                    <option value="宮崎県">宮崎県</option>
                                    <option value="鹿児島県">鹿児島県</option>
                                    <option value="沖縄県">沖縄県</option>
                                </optgroup>
                            </select><br></br>
                            <span className="note">市区郡　（全角30文字以内でご入力ください。　例：墨田区）</span><br></br>
                            <input type="text" className="inputSpace1" onChange={OnChangeWard} value={ward} /><br></br>
                            <span className="note">町・番地　（全角30文字以内でご入力ください。　例：太平４－１－３）</span><br></br>
                            <input type="text" className="inputSpace1" onChange={OnChangeTown} value={town} /><br></br>
                            <span className="note">マンション・建物名　（全角30文字以内でご入力ください。　例：セイホビル３０１）</span><br></br>
                            <input type="text" className="inputSpace1" onChange={OnChangeApartment} value={apartment} />
                            <div className="errDisplayArea">
                                <InputScreenErrorMessage errorMessage={error.blankAddress}></InputScreenErrorMessage>
                                <InputScreenErrorMessage errorMessage={error.charLimitAddress}></InputScreenErrorMessage>
                                <InputScreenErrorMessage errorMessage={error.charNotValidAddress}></InputScreenErrorMessage>
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-3 col-sm-12 col-12 titleDiv">
                            <label htmlFor="inputtext" className="col-form-label l1">{phoneNo}<em className="star">※必須</em></label>
                        </div>
                        <div className="col-lg-9 col-md-9 col-sm-12 col-12 contentDiv">
                            <div className="">
                                <input type="text" onChange={OnChangePhoneNumber} value={phoneNumber} />
                                <div className="errDisplayArea">
                                    <InputScreenErrorMessage errorMessage={error.blankPhone}></InputScreenErrorMessage>
                                    <InputScreenErrorMessage errorMessage={error.charLimitPhone}></InputScreenErrorMessage>
                                    <InputScreenErrorMessage errorMessage={error.charNotValidPhone}></InputScreenErrorMessage>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-3 col-sm-12 col-12 titleDiv">
                            <label htmlFor="inputtext" className="col-form-label l1">E-mail<em className="star">※必須</em></label>
                        </div>
                        <div className="col-lg-9 col-md-9 col-sm-12 col-12 contentDiv">
                                <span className="note">（半角でご入力ください　例：abcd@abcd.co.jp）</span><br></br>
                                <input name="tel" type="text" className='inputSpace1' id='email' size="20" onChange={OnChangeEmail} value={email}></input>
                                <div className="errDisplayArea">
                                    <InputScreenErrorMessage errorMessage={error.blankEmail}></InputScreenErrorMessage>
                                    <InputScreenErrorMessage errorMessage={error.charLimitEmail}></InputScreenErrorMessage>
                                    <InputScreenErrorMessage errorMessage={error.isNotEmail}></InputScreenErrorMessage>
                                </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="">
                <div className="card-container-inputdetails">
                    <div className="row">
                        <span id="span1">当社お問い合わせに関するアンケート</span>
                        <div className="col-lg-3 col-md-3 col-sm-12 col-12 titleDiv">
                            <label htmlFor="inputtext" className="col-form-label l1">{lifeInsurance}<em className="star">※必須</em></label>
                        </div>
                        <div className="col-lg-9 col-md-9 col-sm-12 col-12 contentDiv">
                            <div className="row" value={lifeInsurances} onChange={(e) => OnChangeLifeInsurances(e)}>
                                <div className='checkboxWrap col-lg-4 col-md-4 col-sm-12 col-12'><input type='radio' name='lifeInsurances' value='販売経験あり' />&nbsp;&nbsp;販売経験あり</div>
                                <div className='checkboxWrap col-lg-4 col-md-4 col-sm-12 col-12'><input type='radio' name='lifeInsurances' value='販売経験なし' />&nbsp;&nbsp;販売経験なし</div>
                                <div className="errDisplayArea">
                                    <InputScreenErrorMessage errorMessage={error.blankExperience}></InputScreenErrorMessage>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-3 col-sm-12 col-12 titleDiv">
                            <label htmlFor="inputtext" className="col-form-label l1" style={{ padding: '0px' }}>{metlife}<em className="star">※必須</em></label>
                        </div>
                        <div className="col-lg-9 col-md-9 col-sm-12 col-12 contentDiv">
                            <div className="row" value={metlifeInsurances} onChange={(e) => OnChangeMetlifeInsurances(e)}>
                                <div className='checkboxWrap col-lg-4 col-md-4 col-sm-12 col-12'><input type='radio' name='metlifeInsurances' value='現在登録あり' />&nbsp;&nbsp;現在登録あり</div>
                                <div className='checkboxWrap col-lg-4 col-md-4 col-sm-12 col-12'><input type='radio' name='metlifeInsurances' value='過去に登録歴あり' />&nbsp;&nbsp;過去に登録歴あり</div>
                                <div className='checkboxWrap col-lg-12 col-md-12 col-sm-12 col-12'><input type='radio' name='metlifeInsurances' value='登録したことはない' />&nbsp;&nbsp;登録したことはない</div>
                                <div className="errDisplayArea">
                                    <InputScreenErrorMessage errorMessage={error.blankRegistration}></InputScreenErrorMessage>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-3 col-sm-12 col-12 titleDiv">
                            <label htmlFor="inputtext" className="col-form-label l1">{areaText}</label>
                        </div>
                        <div className="col-lg-9 col-md-9 col-sm-12 col-12 contentDiv">
                                <textarea name="010_DATA" rows="5" cols="60" id="detail" onChange={OnChangeTextArea} value={textArea}></textarea>
                        </div>
                        <div className="errDisplayArea">
                            <InputScreenErrorMessage errorMessage={error.charLimitRemarks}></InputScreenErrorMessage>
                        </div>
                    </div>
                </div>
            </div>
            <div className="">
                <div className="card-container-inputdetails">
                    <div className="contentDiv">
                        <table>
                            <tr>
                                <td>※当社の登録基準に基づき、代理店登録をいただけない場合があります。以下をご確認ください。</td>
                            </tr>
                            <tr>
                                <td className="td1">・会社員、アルバイト等をされつつ副業をお考えの個人</td>
                            </tr>
                            <tr>
                                <td className="td1">・これまでに生命保険・損害保険のいずれも取扱経験のない個人（税理士・公認会計士・IFA等を除く）</td>
                            </tr>
                            <tr>
                                <td className="td1">・生命保険の募集を継続的に行えるマーケットをお持ちでない法人または個人</td>
                            </tr>
                            <tr>
                                <td className="td1">・過去に当社代理店またはぼしゅうにんとして登録があったが、委託期間に生命保険の販売実績がなかった法人または個人</td>
                            </tr>
                            <tr>
                                <td className="td1">・適正な生命保険募集管理体制の構築が困雑であると当社が判断した法人または個人</td>
                            </tr>
                            <tr>
                                <td className="td1">・その他、当社が生命保険の募集に不適正であると判断した場合</td>
                            </tr>
                        </table>
                    </div>
                </div>
            </div>
            <div className="">
                <p>当社では代理店制度に関するご案内を行うことを目的として、個人情報のご提出をお願いしています。</p>
                <div className="card-container-inputdetails">
                    <div className="contentDiv">
                        <table>
                            <tr>
                                <th>情報を収集する目的</th>
                            </tr>
                            <td className="td1">当社では採用審査の参考とすることを目的として個人情報のご提出をお願いしています。<br></br>また、ご提出いただいた個人情報をもとに、採用に関する情報やサービスのご案内・提供を行うことがあります。<br></br>「情報の提供」、「情報の管理方法」については、当社の「個人情報の取扱について」をご参照ください。</td>
                            <tr>
                                <th>個人情報の開示、訂正等、利用停止等</th>
                            </tr>
                            <td className="td1">代理店募集に関して当ページよりご提出頂いた個人情報の開示、訂正等（訂正、追加、削除）、利用停止等（利用停止、消去）のご請求があった場合は、ご本人であることを確認させていただいたうえで、当社業務に支障のない範囲内で対応いたします。手続きについては下記「お問い合わせ先」までご連絡ください。なお、ご要望にお応えできない場合は、ご本人に理由を説明いたします。</td>
                            <tr>
                                <th>お問い合わせ</th>
                            </tr>
                            <td className="td1">メットライフ生命<br></br>代理店部門 代理店営業推進部</td>
                        </table>
                    </div>
                </div>
                <p>代理店制度に関するお問い合わせ以外に関しては、ご回答致しかねますのでご了承ください。<br></br>
                なお、一般的なお問い合わせや請求などは、トップページにある“お問い合わせ”からご参照ください。</p>
                <br></br>
                <div id="align"><p>上記にご同意いただける場合は、「送信」ボタンを押し、入力内容の確認へお進みください。</p>
                    <p className="imgCenter">
                        <input type="image" src={ButtonImage} onClick={submitButtonClick} value="" alt="送信" />
                    </p>
                </div>
            </div>
            </div>
        </div>
    )
}

export default DairitenFormPage
